"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var get_label_string_1 = require("./get-label-string");
var intl_format_1 = require("@biw/intl-format");
var contests_constants_1 = require("@biw/contests-constants");
var formatFixedRateString = function (str, _a) {
    var goalLabel = _a.goalLabel, goalRoundingMethod = _a.goalRoundingMethod, locale = _a.locale;
    return get_label_string_1.getLabelString(goalLabel, str, goalLabel.precision, goalRoundingMethod, locale);
};
var formatFixedRateMessage = function (_a) {
    var getString = _a.getString, incrementQuantity = _a.incrementQuantity, goalAchieveAmount = _a.goalAchieveAmount, locale = _a.locale, incrementAward = _a.incrementAward, maxPoints = _a.maxPoints, mediaLabel = _a.mediaLabel, goalLabel = _a.goalLabel, goalRoundingMethod = _a.goalRoundingMethod;
    var _b = tslib_1.__read(getString('common.fixedRate.payoutMessage').split('#IF'), 2), 
    // 'For every <strong>${incrementQuantityStr}</strong> over <strong>${goalAchieveAmountStr}</strong>, earn an additional <strong>${incrementAward} ${mediaLabel}</strong> '
    message = _b[0], 
    // '(up to <strong>${maxPoints} ${mediaLabel}</strong> maximum).'
    maxPointsMessage = _b[1];
    var fixedPlusRateReplaceOpts = {
        incrementQuantityStr: formatFixedRateString(incrementQuantity, { goalLabel: goalLabel, goalRoundingMethod: goalRoundingMethod, locale: locale }),
        goalAchieveAmountStr: formatFixedRateString(goalAchieveAmount, { goalLabel: goalLabel, goalRoundingMethod: goalRoundingMethod, locale: locale }),
        incrementAward: intl_format_1.formatNumber(locale, {}, incrementAward),
        maxPoints: intl_format_1.formatNumber(locale, {}, maxPoints),
        mediaLabel: mediaLabel
    };
    if (maxPoints) {
        return ("" + message + maxPointsMessage).template(fixedPlusRateReplaceOpts);
    }
    else {
        return message.template(fixedPlusRateReplaceOpts);
    }
};
/*
 * returns a fixed plus rate payout message for a pax Goal Selection
 */
exports.getFixedPlusRatePayoutMessage = function (_a) {
    var goalPayoutTierType = _a.goalPayoutTierType, getString = _a.getString, incrementQuantity = _a.incrementQuantity, goalAchieveAmount = _a.goalAchieveAmount, locale = _a.locale, incrementAward = _a.incrementAward, maxPoints = _a.maxPoints, mediaLabel = _a.mediaLabel, goalLabel = _a.goalLabel, goalRoundingMethod = _a.goalRoundingMethod;
    if (goalPayoutTierType === contests_constants_1.payoutType.PT__FIXED_RATE) {
        return formatFixedRateMessage({
            getString: getString,
            incrementQuantity: incrementQuantity,
            goalAchieveAmount: goalAchieveAmount,
            locale: locale,
            incrementAward: incrementAward,
            maxPoints: maxPoints,
            mediaLabel: mediaLabel,
            goalLabel: goalLabel,
            goalRoundingMethod: goalRoundingMethod
        });
    }
};
/*
 * returns an array of fixed plus rate payout messages
 */
exports.getFixedPlusRatePayoutArray = function (_a) {
    var goalPayoutTierType = _a.goalPayoutTierType, goalLevels = _a.goalLevels, getString = _a.getString, locale = _a.locale, mediaLabel = _a.mediaLabel, goalLabel = _a.goalLabel, goalRoundingMethod = _a.goalRoundingMethod;
    if (goalPayoutTierType === contests_constants_1.payoutType.PT__FIXED_RATE && goalLevels && goalLevels.length > 0) {
        return goalLevels.map(function (level) { return formatFixedRateMessage({
            getString: getString,
            locale: locale,
            mediaLabel: mediaLabel,
            goalLabel: goalLabel,
            goalRoundingMethod: goalRoundingMethod,
            incrementQuantity: level.incrementQuantity,
            goalAchieveAmount: level.goalAchieveAmount,
            incrementAward: level.incrementAward,
            maxPoints: level.maxPoints
        }); });
    }
};
//# sourceMappingURL=get-fixed-rate.js.map